import React from "react";

import { useLocation } from "react-router-dom";

import LeftMenu from "../components/LeftMenu";
import MediaBrowse from "../components/media-browse/MediaBrowse";
import MobileMenu from "../components/MobileMenu";
import useFontSize from "../hooks/useFontSize";
import webPlayerStorage from "../utils/webPlayerStorage";

const WebPlayerSeries = () => {
  useFontSize();
  const location = useLocation();
  const profile =
    location.state?.profile ||
    JSON.parse(sessionStorage.getItem("selectedProfile") || "{}");
  const playlist =
    location.state?.playlist ||
    JSON.parse(localStorage.getItem("selectedPlaylist") || "{}");

  return (
    <div>
      <MobileMenu />
      <button
        className="fixed bottom-4 right-4 sm:bottom-8 sm:right-8 z-50 text-white text-xs sm:text-sm font-medium bg-black/50 px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg opacity-40 hover:opacity-100 hover:scale-105 transition-all duration-300"
        onClick={() => {
          webPlayerStorage.clearAll();
          window.location.href = "https://dashboard.lunova.app";
        }}
      >
        Dashboard
      </button>
      <LeftMenu activeMenuItem="series" playlist={playlist} profile={profile} />
      <MediaBrowse mediaType="series" playlist={playlist} profile={profile} />
    </div>
  );
};

export default WebPlayerSeries;
